var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRedirectBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pajamas:arrow-up",
    clipPath: "url(#clip0_1430_11889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5726 18.951C21.5283 19.0954 21.5137 19.2473 21.5294 19.3976C21.5452 19.5478 21.591 19.6934 21.6642 19.8255C21.7375 19.9577 21.8365 20.0737 21.9556 20.1667C22.0746 20.2598 22.2112 20.3279 22.3571 20.367C22.503 20.4061 22.6554 20.4154 22.805 20.3943C22.9546 20.3733 23.0984 20.3223 23.2279 20.2445C23.3574 20.1667 23.4699 20.0635 23.5586 19.9413C23.6474 19.819 23.7106 19.6802 23.7445 19.533L25.5302 12.8728L25.8212 11.7868L24.7352 11.4958L18.0758 9.71148C17.7897 9.63995 17.4868 9.6837 17.2326 9.83328C16.9784 9.98287 16.793 10.2263 16.7166 10.5112C16.6401 10.7961 16.6785 11.0997 16.8237 11.3565C16.9688 11.6133 17.209 11.8028 17.4926 11.8842L21.5292 12.9658L8.04646 20.7501C7.78806 20.8992 7.59951 21.145 7.52229 21.4332C7.44507 21.7214 7.48549 22.0284 7.63468 22.2868C7.78386 22.5452 8.02958 22.7338 8.31779 22.811C8.60599 22.8882 8.91306 22.8478 9.17146 22.6986L22.6542 14.9144L21.5726 18.951Z",
    fill: "#0516C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1430_11889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21.1211 0.644531) rotate(60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRedirectBlue);
export default __webpack_public_path__ + "static/media/arrow-redirect-blue.7520e0f913f49efd8b1a57854e2306ca.svg";
export { ForwardRef as ReactComponent };